<template>
  <div>
    <div class="vx-col w-full mb-base">
      <h3>Password reset</h3>
    </div>
    <div class="flex flex-wrap">
      <vs-button color="danger" type="filled" @click="sendPasswordResetEmail">Send Password Reset Email</vs-button>
    </div>
    <p class="mt-4">Note: you will be logged out</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      old_password: '',
      new_password: '',
      confirm_new_password: ''
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    sendPasswordResetEmail () {
      this.$fauth.sendPasswordResetEmail(this.activeUserInfo.email).then(() => {
        this.$vs.notify({
          title: 'Email Sent',
          text: 'A password reset email has been sent to you',
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'success',
          position: 'top-center'
        })
        this.logout()
      }).catch(error => {
        console.log(error)
      })
    },
    logout () {
      localStorage.removeItem('userInfo')
      this.$router.push('/login').catch(() => {})
    }
  }
}
</script>
